import styles from "./DeleteHistoryModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import Checkbox from "shared/@forms/Checkbox";
import { useState } from "react";
import { Ok } from "react-ikonate";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for deleting content history in the members tab of the groups page.
 */

export function DeleteHistoryModal({ isOpen, onClose, onClick, continueBool }) {
  const [checked, setChecked] = useState(continueBool);
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="DELETE CONTENT HISTORY"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.description}>
              Confirm that you would like to delete all content older than 30
              days.
            </div>

            <div
              className={classNames(
                styles.checkboxContainer,
                checked && styles.checked
              )}
              onClick={() => setChecked(!checked)}
            >
              <div
                className={classNames(styles.icon, !checked && styles.hidden)}
              >
                <Ok />
              </div>
            </div>
            <div className={styles.checkboxLabel}>
              Continue with deletion even if group is not a controlled LOS
              group.
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button
                className={classNames(styles.button, styles.deleteButton)}
                onClick={() => onClick(checked)}
              >
                DELETE
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

DeleteHistoryModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  continueBool: PropTypes.bool,
};
